import React from 'react';
import { Col } from 'react-bootstrap';
import { FormLabelProps } from 'Components/Common/Form/FormLabel/form-label';
import ChipToolTip from 'Components/Common/ChipToolTip/ChipToolTip';

export const labelRequire = (label: string, classLabel?: string): JSX.Element | string => {
  if (label && label.includes('*')) {
    const title = label.split('*')[0].trim();
    return (
      <span className={`${classLabel}`}>
        {title} <span className="txt-require">*</span>
      </span>
    );
  }

  return <span className={`${classLabel}`}>{label}</span>;
};

export const labelRequireChip = (
  label: string,
  classLabel?: string,
  isSubRequired?: boolean,
): JSX.Element | string => {
  const title = label.split('*')[0].trim();
  return (
    <>
      <div
        className={`${classLabel} d-flex flex-row w-100 gap-2 align-items-center justify-content-between`}
      >
        <div className="px-0 w-100">{title}</div>
        <div className="p-0">
          <div className={`align-items-center gap-2 d-flex flex-row `}>
            <div>
              {isSubRequired && (
                <ChipToolTip
                  chipClass="chip-main"
                  tooltipText="一時保存で予約販売を行う場合に入力が必要な項目"
                  text="必須"
                />
              )}
            </div>
            <div>
              <ChipToolTip
                chipClass="chip-secondary"
                tooltipText="登録済みとする場合に入力が必要な項目"
                text="必須"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <Row className={`${classLabel} align-items-center`}>
        <Col md={8} className="px-0">
          {title}
        </Col>
        <Col md={4} className="p-0">
          <Row className={`align-items-center g-2`}>
            <Col md={6}>
              {isSubRequired && (
                <ChipToolTip
                  chipClass="chip-main"
                  tooltipText="一時保存で予約販売を行う場合に入力が必要な項目"
                  text="必須"
                />
              )}
            </Col>
            <Col md={6}>
              <ChipToolTip
                chipClass="chip-secondary"
                tooltipText="登録済みとする場合に入力が必要な項目"
                text="必須"
              />
            </Col>
          </Row>
        </Col>
      </Row> */}
    </>
  );
};

export default function FormLabel(props: FormLabelProps): JSX.Element {
  const { label, classForm, colMd, classLabel } = props;

  return (
    <Col md={colMd} className={`${classForm}`}>
      {labelRequire(label, classLabel)}
    </Col>
  );
}
